import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from "rxjs";
import { MemberProfileActions } from "./member-profile-action.types";
import { MemberProfileKey } from "@shared/local-storage.key";
import { PlatformService } from "@core/services/platform.service";
import { DomainService } from "@core/services/domain.service";
import { TranslateService } from "@ngx-translate/core";
import { RequestReceiptHttpService } from "@core/services/request-receipt-http.service";

@Injectable({
  providedIn: 'root'
})
export class MemberProfileEffects {

  /* SetMemberProfile fires on every profile refresh; start the request-receipt listener once per member. */
  private requestReceiptMemberId: number | null = null;

  constructor(
    private platformService: PlatformService,
    private domainService: DomainService,
    private translateService: TranslateService,
    private requestReceiptHttpService: RequestReceiptHttpService,
  ) { }

  setMemberProfile$ = createEffect(() =>
    inject(Actions).pipe(
      ofType(MemberProfileActions.SetMemberProfile),
      tap(async action => {
        if (this.platformService.isBrowser()) {
          /* Add code here */
          console.debug("Member Profile Effects: Set Member Profile");
          localStorage.setItem(MemberProfileKey, JSON.stringify(action));

          /* Start: Locale part */
          const userLocale = `${action.lang_code.toLowerCase()}-${action.country_code.toLowerCase()}`;
          if (this.domainService.getLocale() != userLocale) {
            let
              fullDomain = window.location.href,
              oldLocale = this.domainService.getLocale();

            this.domainService.setLocale('browser', userLocale);
            this.translateService.use(this.domainService.getLanguageCode());
            window.history.replaceState({}, '', fullDomain.replace(oldLocale, this.domainService.getLocale()));
          }
          /* End: Locale part */

          /* Pending "upload your receipt" request + its websocket, as template-02 started from
             auth.effects on login. Feeds the global <app-request-receipt> popup and History's
             Cancel Deposit / notification dot. */
          if (this.requestReceiptMemberId !== action.id) {
            this.requestReceiptMemberId = action.id;
            this.requestReceiptHttpService.init(action.id).catch(err => console.warn("Request receipt init failed", err));
          }
        }
      })
    ),
    { dispatch: false }
  );

  unsetMemberProfile$ = createEffect(() =>
    inject(Actions).pipe(
      ofType(MemberProfileActions.UnsetMemberProfile),
      tap(() => {
        if (this.platformService.isBrowser()) {
          /* Add code here */
          console.debug("Member Profile Effects: Unset Member Profile");
          localStorage.removeItem(MemberProfileKey);
          this.requestReceiptHttpService.disconnectSocket();
          this.requestReceiptMemberId = null;
        }
      })
    ),
    { dispatch: false });
}
